const configButton = () => {
    $(".header-button").click(function (){

        $('html, body').animate({
            scrollTop: $("#configurador").offset().top
        }, 1000, 'linear');
    });
};

export { configButton };